import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';

const TranslationEn = require('../../../assets/i18n/en.json');

@Injectable()
export class LocalTranslateLoader implements TranslateLoader {
  private translations: any = {
    en: TranslationEn,
  };

  public getTranslation(lang: string): Observable<any> {
    return Observable.of(this.translations[lang]);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/translator/local-translate-loader.service.ts